<template>
  <div class="box">
    <div class="section-label">
      {{ tc('booking.taxesAndFees') }}
    </div>
    <see-details>
      <div class="overview-item">
        <div class="item-label bold-item">
          {{ tc('booking.total') }} {{ tc('booking.taxesAndFees') }}
        </div>
        <div class="item-value bold-item">
          {{ totalTaxes }}
        </div>
      </div>
      <add-ons-taxes-overview v-if="addOnsInCart.length > 0" />
      <template #details>
        <div class="overview-items-wrapper">
          <div
            v-for="(key, i) in itemsToJoin"
            :key="key"
            class="overview-item"
            :class="[
              { 'small-margin': i < itemsToJoin.length - 1 }
            ]"
          >
            <div class="item-label section-label">
              {{ key }}
            </div>
            <div class="item-value">
              {{ getDisplayPrice({price: mergedTaxesAndFees[key]}) }}
            </div>
          </div>
        </div>
      </template>
    </see-details>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { ensureNumber } from '@utils/currency-helpers'
  import SeeDetails from '../../../components/see-details/see-details.vue'
  import AddOnsTaxesOverview from './add-on-taxes-overview.vue'

  export default {
    name: 'TaxesOverview',
    components: {
      SeeDetails,
      AddOnsTaxesOverview
    },
    props: {
      cart: {
        type: Object,
        required: true
      }
    },
    computed: {
      ...mapGetters('i18n', ['tc']),
      ...mapGetters('currency', ['getDisplayPrice', 'currencyData']),
      ...mapGetters('cart', ['addOnsInCart', 'addOnsTotalTaxes']),
      linesTaxesAndFees() {
        return this.cart.lines.map((l) => l.taxesFees.map((t) => ({ description: t.description, price: ensureNumber(t.price) })))
      },
      mergedTaxesAndFees() {
        const taxesAndFees = {}
        this.linesTaxesAndFees.forEach((line) => {
          line.forEach((tax) => {
            if (taxesAndFees[tax.description]) {
              taxesAndFees[tax.description] = taxesAndFees[tax.description] + tax.price
            } else {
              taxesAndFees[tax.description] = tax.price
            }
          })
        })
        return taxesAndFees
      },
      itemsToJoin() {
        return Object.keys(this.mergedTaxesAndFees)
      },
      totalTaxes() {
        let total = this.itemsToJoin.map((key) => this.mergedTaxesAndFees[key]).reduce((a, b) => a + b, 0)
        if (this.addOnsInCart.length > 0) {
          total += this.addOnsTotalTaxes
        }
        return this.getDisplayPrice({ price: total })
      },
    }
  }
</script>
